import { BehaviorSubject, Subject } from "rxjs";

export class ActionTabletContext {

    private currentlyActiveStationInternal: number;
    selectedStations = new Array<number>();
    widgetIdentifier: string;

    public showStationDetails = true;
    public showWaitingMovementOrders = false;

    set currentlyActiveStation(currentlyActiveStation: number) {
      this.currentlyActiveStationInternal = currentlyActiveStation;
      this.currentlyActiveStationChanged.next(currentlyActiveStation);
    }

    get currentlyActiveStation() {
      return this.currentlyActiveStationInternal;
    }

    public contextReady = new BehaviorSubject<void>(null);

    public currentlyActiveStationChanged = new Subject<number>();

}
